import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { Box, StackLayout } from '@leagueplatform/genesis-core';

export const DiffCell = ({
  oldValue,
  newValue,
}: {
  oldValue: unknown;
  newValue: unknown;
}) => {
  const { formatMessage } = useIntl();
  const noDataPlaceholder = `<${formatMessage({ id: 'NO_DATA' })}>`;
  const toDisplayString = (value: unknown) => {
    const stringValue = value == null ? '' : String(value);
    return stringValue.trim() === '' ? noDataPlaceholder : stringValue;
  };
  const displayOldValue = toDisplayString(oldValue);
  const displayNewValue = toDisplayString(newValue);
  return (
    <StackLayout orientation="vertical" spacing="$quarter">
      <Box
        as="del"
        aria-label={formatMessage(
          { id: 'OLD_VALUE_TO_BE_REPLACED' },
          { value: displayOldValue },
        )}
        css={{
          textDecoration: 'line-through',
          color: '$onSurfaceTextCritical',
          backgroundColor: '$criticalBackgroundSubdued',
          fontStyle:
            displayOldValue === noDataPlaceholder ? 'italic' : 'normal',
        }}
      >
        {displayOldValue}
      </Box>
      <Box
        as="ins"
        aria-label={formatMessage(
          { id: 'NEW_VALUE' },
          { value: displayNewValue },
        )}
        css={{
          textDecoration: 'none',
          color: '$onSurfaceTextSuccess',
          backgroundColor: '$successBackgroundSubdued',
          fontStyle:
            displayNewValue === noDataPlaceholder ? 'italic' : 'normal',
        }}
      >
        {displayNewValue}
      </Box>
    </StackLayout>
  );
};
